import React from 'react';
import styled from 'styled-components';
import { layout, remCalc } from '@prisjakt/ui-base';
import HideableBox from '@prisjakt/ui-hideable-box';
import { HideableBoxProps } from '@prisjakt/ui-hideable-box/src/types';
import { MenuItem } from '../../../../../sidebar/views/user/styles';

type CategoryProps = {
  sidebar: boolean;
};

export const Categories = styled(
  ({ ...props }: CategoryProps & HideableBoxProps) => <HideableBox {...props} />
).attrs({
  speed: 'FAST',
  delayIn: 'SHORTER',
  fade: false,
})<HideableBoxProps>`
  flex-direction: column;
  padding-bottom: ${layout.spacing.xSmall};
  width: 100%;
`;

export const CategoryListHeading = styled.h2`
  font-size: ${remCalc(10)};
  font-weight: normal;
  letter-spacing: 1.5px;
  margin: 0;
  padding: ${layout.spacing.xSmall};
  text-transform: uppercase;
`;

export const CategoryLogo = styled.img`
  height: 40px;
  width: 40px;
`;

export const ViewAllMenuItem = styled(MenuItem)`
  color: ${props =>
    props.sidebar ? props.theme.text.callToAction : props.theme.text.primary};
`;

export const StylesMenuItem = styled(MenuItem)``;
